﻿$.fn.dxCtrlFichier2Table = function custom_dxCtrlFichier2Table(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2table dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Table(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Table = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var _isDirty = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') _isDirty = value
        return _isDirty
    }

    this.mGetDataSource = function () {
        return dataSourceObjet
    }

    //if (typeof option.isExterne == "undefined") option.isExterne=false

    var dataSourceObjet = []
    var dxFichierResume = null;
    function mConstruit() {
        container.empty()
        dataSourceObjet = []
        option.bddCtrl.mGetArray("fichier_table").filter(function (o) {
            return o.id == option.id && o.id_table == option.id_table
        }).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) || parseInt(o1.id_fichier_table) - parseInt(o2.id_fichier_table) }).forEach(function (dataFichierTable) {
            var item = {
                url: "/Fichier/" + option.bddCtrl.nom_base + "/bdd/fichier_table/" + dataFichierTable.id_fichier_table + "/" + dataFichierTable.nom,
                data: dataFichierTable
            }
            dataSourceObjet.push(item)
        })

        dxFichierResume = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlFichier2Resume({
            bddCtrl: option.bddCtrl,
            dataSource: dataSourceObjet,
            typeVisu: option.typeVisu,
            readOnly: option.readOnly,
            containerBtAdd: option.containerBtAdd,
            accept: option.accept,
            widthVignette: option.widthVignette,
            onReorder: function (itemData) {
                var objets = option.bddCtrl.getObjets()
                dataSourceObjet.forEach(function (itemData, idx) {
                    itemData.data.tri = idx
                    objets.mAddData([itemData.data], "save")
                })
                objets.mSave(function () { })
                _isDirty = true
            },
            onDeleteFiles: function (lstItemDataToDel,funcEnd) {
                var objets = option.bddCtrl.getObjets()
                lstItemDataToDel.forEach(function (itemData) {
                    objets.mAddData([itemData.data], "suppdef")
                    dataSourceObjet.splice(dataSourceObjet.indexOf(itemData), 1)
                })
                objets.mSave(function () {
                    if (funcEnd) funcEnd()
                })
                _isDirty = true
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            },
            onAddFiles: function (lstNewUrlFile, funcOk) {
                if (typeof option.onBeforeChange != "undefined") { option.onBeforeChange(function () { mAddFiles() }) }
                else { mAddFiles() }
                function mAddFiles() {
                    _isDirty = true
                    mSaveTableFichier(0)
                    var lstNewItemData = []
                    if (lstNewUrlFile.length>2) jaugeDemarrage.mShow()
                    function mSaveTableFichier(idx) {
                        if (typeof lstNewUrlFile[idx] != 'undefined') {
                            var urlFile = lstNewUrlFile[idx]
                            option.bddCtrl.mAjaxCall({
                                command: "save_table_fichier_with_url",
                                urlfile: urlFile,
                                id: option.id,
                                id_table: option.id_table
                            }, function (data) {
                                var dataFichierTable = option.bddCtrl.getObjet("fichier_table", data.id_fichier_table).data
                                var item = {
                                    url: "/Fichier/" + option.bddCtrl.nom_base + "/bdd/fichier_table/" + dataFichierTable.id_fichier_table + "/" + dataFichierTable.nom,
                                    data: dataFichierTable
                                }
                                option.bddCtrl.triggerFunctionOnModifiedItemData("fichier_table", "modif", dataFichierTable)
                                lstNewItemData.push(item)
                                dataSourceObjet.push(item)
                                mSaveTableFichier(idx + 1)
                                if (typeof option.onSaveFichierTable != 'undefined') option.onSaveFichierTable(dataFichierTable)
                            });
                        } else {
                            jaugeDemarrage.mHide()
                            funcOk(lstNewItemData)
                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        }
                    }
                }
            },
            onModifFiles: function (lstItemData) {
                _isDirty = true
            }
        }).dxCtrlFichier2Resume("instance")
    }

    this.mReload = function () {
        mConstruit()
    }

    this.mShowVisu = function (itemData) {
        dxFichierResume.mShowVisu(itemData)
    }

    this.mGetItem = function (idFichierTable) {
        return dataSourceObjet.filter(function (o) { return o.data.id_fichier_table == idFichierTable })[0]
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}